<template>
  <div class="company-data">
    <div class="company-data__basic-info">
      <div class="company-data__label">
        <v-icon size="22px" color="primary" class="mr-1">
          icon-owner
        </v-icon>
        <span>{{ $t("message.reviews.categories.dataFor") }}:</span>
      </div>
      <div>
        <div class="company-data__title">{{ companyName }}</div>
        <span class="company-data__secondary-text">
          <span v-html="facilityName"></span>
          <span v-if="facilityCount" class="company-data__secondary-quantity">
            {{ getFacilitiesCountLabel }}
          </span>
        </span>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
import { pluralCount } from "@/helpers/helpers";
import { mapGetters } from "vuex";

export default {
  name: "ReviewsCategoriesCompanyData",
  computed: {
    ...mapGetters("reviewsCategoriesAnalytics", {
      facilityName: "getFacilityDisplayName",
      facilityCount: "getFacilityCount"
    }),
    companyName() {
      return this.$store.state.company.company.name;
    },
    getFacilitiesCountLabel() {
      return this.facilityCount > 0
        ? `(${pluralCount("message.pluralForms.facility", this.facilityCount)})`
        : "";
    }
  }
};
</script>
<style lang="scss" scoped>
.company-data {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 0 $spacing * 4 0;
  gap: $spacing * 3;

  &__basic-info {
    display: flex;
    align-items: center;
  }

  &__label {
    color: $primary;
    margin-right: $spacing * 1.5;
  }

  &__title {
    @include font-size(16px);
    line-height: 1rem;
  }

  &__secondary-text {
    @include font-size(14px);
    font-weight: 400;
  }
  &__secondary-quantity {
    @include font-size(14px);
    font-weight: 400;
    color: $primary;
  }
}
</style>
